import PropTypes from 'prop-types';
import { memo, useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { months } from '@asterCore/Profile/AutoScrollForm/utils';
import { DropdownControl } from '../Forms';
import ExpiryDateStyled from './ExpiryDateStyled';

const ExpiryDate = ({ getExpiryDate, errorMessage, name, expiryDate, disabled, labelText }) => {
  const [date, setDate] = useState();
  const [month, setMonth] = useState();
  const [year, setYear] = useState();
  const [leapYear, setLeapYear] = useState(false);
  const d = new Date();
  const currentYear = d.getFullYear();
  const [dates, setDates] = useState([]);
  const [datesData, setDatesData] = useState([]);
  const [monthsData, setMonthsData] = useState([]);
  const [yearsData, setYearsData] = useState([]);

  const years = [];

  const getSelectedMonthDates = (monthVal, isLeapYear) => {
    if (['January', 'March', 'May', 'July', 'August', 'October', 'December'].includes(monthVal)) {
      const arr31days = Array.from({ length: 31 }, (_, index) => index + 1);
      setDates(arr31days);
    } else if (['November', 'April', 'June', 'September'].includes(monthVal)) {
      const arr30days = Array.from({ length: 30 }, (_, index) => index + 1);
      setDates(arr30days);
    } else if (monthVal === 'February' && isLeapYear) {
      const arr29days = Array.from({ length: 29 }, (_, index) => index + 1);
      setDates(arr29days);
    } else if (monthVal === 'February' && !isLeapYear) {
      const arr28days = Array.from({ length: 28 }, (_, index) => index + 1);
      setDates(arr28days);
    } else {
      const arr31days = Array.from({ length: 31 }, (_, index) => index + 1);
      setDates(arr31days);
    }
  };

  const arrayElement = (dateData) => {
    const arr = [];
    if (dateData.length > 0) {
      dateData.forEach((element) => {
        if (typeof element === 'string') {
          arr.push({ text: element });
        } else {
          const text = element < 10 ? `0${element}` : `${element}`;
          arr.push({ text });
        }
      });
    }
    return arr;
  };

  useEffect(() => {
    for (let i = currentYear; i <= currentYear + 100; i++) {
      years.push(i);
    }
    setMonthsData(arrayElement(months));
    setDatesData(arrayElement(dates));
    setYearsData(arrayElement(years));
  }, [year, currentYear, dates]);

  useEffect(() => {
    if (expiryDate) {
      setYear(`${expiryDate?.getFullYear()}`);
      setMonth(months[expiryDate?.getMonth()]);
      setDate(Number(expiryDate.getDate()) < 10 ? `0${expiryDate.getDate()}` : `${expiryDate.getDate()}`);
    }
    else {
      setDate('');
      setMonth('');
      setYear('');
    }
  }, [expiryDate]);

  useEffect(() => {
    if (!expiryDate) {
      if (['31'].indexOf(date) >= 0 && ['November', 'April', 'June', 'September', 'February'].indexOf(month) >= 0) {
        setDate('');
      } else if (['30'].indexOf(date) === 0 && ['February'].indexOf(month) === 0) {
        setDate('');
      } else if (!leapYear && ['29'].indexOf(date) === 0 && ['February'].indexOf(month) === 0) {
        setDate('');
      } else {
        setDate(date);
      }
    }
  }, [date, month]);

  useEffect(() => {
    if (Number(year) % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      setLeapYear(true);
    } else {
      setLeapYear(false);
    }
  }, [year]);

  useEffect(() => {
    getSelectedMonthDates(month, leapYear);
  }, [month, leapYear]);

  useEffect(() => {
    if (year && month && date) {
      getExpiryDate(new Date(Number(year), months.indexOf(month), Number(date)));
    }
  }, [year, month, date]);

  return (
    <ExpiryDateStyled disabled={disabled}>
      <div className="form-label">{labelText}</div>
      <Row className="expiry-date-wrapper">
        <Col lg={4} sm={4} xs={4}>
          <DropdownControl
            countryClass={errorMessage ? 'error-border' : 'dobdropdown'}
            data={datesData}
            theme="dobdropdown"
            caption="DD"
            selected={date}
            handleSelect={(val) => {
              setDate(val);
            }}
            name={name}
            disabled={disabled}
          />
        </Col>
        <Col lg={4} sm={4} xs={4}>
          <DropdownControl
            data={monthsData}
            countryClass={errorMessage ? 'error-border' : 'dobdropdown'}
            theme="dobdropdown"
            caption="MM"
            selected={month}
            handleSelect={(val) => {
              setMonth(val);
            }}
            name={name}
            disabled={disabled}
          />
        </Col>
        <Col lg={4} sm={4} xs={4}>
          <DropdownControl
            data={yearsData}
            countryClass={errorMessage ? 'error-border' : 'dobdropdown'}
            theme="dobdropdown"
            caption="YYYY"
            selected={year}
            handleSelect={(val) => {
              setYear(val);
            }}
            name={name}
            disabled={disabled}
          />
        </Col>
      </Row>
      {errorMessage ? (
        <Form.Control.Feedback type="invalid" className={errorMessage ? 'd-block' : ''}>
          {errorMessage}
        </Form.Control.Feedback>
      ) : null}
    </ExpiryDateStyled>
  );
};

ExpiryDate.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  getExpiryDate: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  expiryDate: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  labelText: PropTypes.string.isRequired,
};

export default memo(ExpiryDate);
